export default "__VITE_ASSET__ecea1ca6__"